export default __webpack_public_path__ + "media/images/pp_logo-7405d9ee408f0f903ad6ef4e968eda89.png";